import React from 'react';
import {
  number,
  func,
  bool,
} from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage } from 'react-intl';
import Button from 'common/mdc/button';
import Icon from 'common/mdc/icon';

const messages = defineMessages({
  advanced: {
    id: 'components.search.advanced.summary',
    defaultMessage: '{count} Advanced',
  },
});

const AdvancedSummary = ({
  className,
  count,
  isExpanded,
  toggleAdvancedSearch,
}) => (
  <Button
    className={classnames(
      className,
      'advanced-summary',
    )}
    raised={isExpanded}
    onClick={() => toggleAdvancedSearch()}
  >
    <FormattedMessage
      values={{
        count: count ? <b>{count}</b> : '',
      }}
      {...messages.advanced}
    />
    <Icon className="mdc-button__icon">
      {isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }
    </Icon>
  </Button>
);

AdvancedSummary.propTypes = {
  count: number.isRequired,
  toggleAdvancedSearch: func.isRequired,
  isExpanded: bool.isRequired,
};

export default AdvancedSummary;
